module.exports = __webpack_public_path__ + "img/screenshots.683443d6.svg";